import React, { Fragment } from 'react';
import useWallet from '../hooks/useWallet';
import NavItemDropdown from '../components/navItemDropdown';
import Config from '../utils/config';
import Label from '../utils/label';
import { isEmpty } from '../utils/common';

const showTransferFunds = Config.appConfig.getAccountMenu && JSON.parse(Config.appConfig.getAccountMenu).ShowTransferFunds;

export default function Wallet(props) {
    const {
        isLoading,
        refreshWalletInfo,
        walletInfo,
        showBalance,
        onShowBalanceClick
    } = useWallet();

    function popWin(e) {
        props.openDepositPage(e.currentTarget.dataset.type, Config.appConfig.SiteTitle);
    }

    const currency = !isEmpty(walletInfo) ? walletInfo.Currency : Config.appConfig.Currency;
    const balance = !isEmpty(walletInfo) ? walletInfo.Balance.walletBalance : Config.appConfig.Balance;
    const lastLogin = !isEmpty(walletInfo) ? walletInfo.LastLogin : Config.appConfig.LastLogin;
    const lastTrans = !isEmpty(walletInfo) ? walletInfo.LastTrans : Config.appConfig.LastTrans;

    return (
        <NavItemDropdown
            dropdownButton={<WalletButton balance={showBalance ? `${currency} ${balance}` : `${Label.lbl_balance} (${currency})`} />}
            dropdownButtonClick={refreshWalletInfo}
            dropdownMenuClassName="wallet"
        >
            <label htmlFor="CheckTerm">
                <input type="checkbox" id="CheckTerm" checked={showBalance} onChange={onShowBalanceClick} />
                {Label.lbl_Show_Balance}
            </label>
            <div className="wallet-header">
                <div className="wallet-header-caption">{currency}</div>
                <div className="wallet-header-chips">{balance}</div>
                <div className={`btn btn-small btn-info ${isLoading ? 'spin' : ''}`} data-tag="tabSmallBtnIcon">
                    <i className="icon-refresh" onClick={refreshWalletInfo} />
                </div>
            </div>
            {!isEmpty(walletInfo) && <WalletList balance={walletInfo.Balance} />}
            <div className="wallet-footer">
                <a href="javascript:void(0)" className="btn btn-primary" data-type="0" onClick={popWin}>
                    {Label.lbl_TransactionTitle}
                </a>
                {showTransferFunds && (
                    <a href="javascript:void(0)" className="btn btn-primary" data-type="2" onClick={popWin}>
                        {Label.lbl_TransferFunds}
                    </a>
                )}
            </div>
            <ul className="wallet-time">
                <li>
                    <span className="wallet-time-title">{Label.lbl_LastLogin}</span>
                    <span className="wallet-time-info">{lastLogin}</span>
                </li>
                <li>
                    <span className="wallet-time-title">{Label.lbl_LastTrans}</span>
                    <span className="wallet-time-info">{lastTrans}</span>
                </li>
            </ul>
        </NavItemDropdown>
    );
}

function WalletButton(props) {
    return (
        <Fragment>
            <i className="icon-balance" />
            {props.balance}
        </Fragment>
    );
}

function WalletList({ balance }) {

    function WalletListItem({ label, balance, thirdcontent }) {
        return (
            <Fragment>
            <li className="wallet-list-item ">
                <span className="wallet-list-title">{label}</span>
                <span className="wallet-list-info">{balance}</span>
            </li>
            {thirdcontent && (
                <ul className="third-content">
                    {thirdcontent.map((content, key) => content && (
                        <WalletListItem key={key} {...content} />
                    ))}
                </ul>
            )}
            </Fragment>
        );
    }

    const contents = [
        {
            label: Label.lbl_sports,
            balance: balance.sportsBalance,
        },
        balance.LivecasinoBalance && { label: Label.lbl_Livecasino, balance: balance.LivecasinoBalance },
        balance.AGBalance && { label: Label.lbl_AG, balance: balance.AGBalance },
        balance.LotteryBalance && { label: Label.lbl_Lottery, balance: balance.LotteryBalance },
        balance.GD_LiveCasinoBalance && { label: Label.lbl_GD_LiveCasino, balance: balance.GD_LiveCasinoBalance },
        balance.ExchangeBalance && { label: Label.lbl_Exchange, balance: balance.ExchangeBalance },
    ];
    return (
        <ul className="wallet-list">
            {contents.map((content, index) => content && (
                <WalletListItem key={index} {...content} />
            ))}
        </ul>
    );
}